import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function FormActions({
  children,
}) {
  return (
    <div className="flex items-center justify-end w-full pt-4">
      {children}
    </div>
  );
}

FormActions.defaultProps = defaultProps;
FormActions.propTypes = propTypes;
